import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton, HeadingItem } from 'components'
import { ItemDetailInfo } from 'components/item-verification'
import React, { FC } from 'react'
import { LineItem } from 'services/types'
import './lineitem-card.scss'

type Props = {
    lineItem: LineItem
    onClickButton: (lineItem: LineItem) => void
}

export const LineItemCard: FC<Props> = ({ lineItem, onClickButton }) => {

    return (
        <div className={'search-result-card-material'}>
            <HeadingItem text={lineItem.longDescription!} />
            <ItemDetailInfo title={'Item ID'} value={lineItem.manufacturerItemId} position={'left'} />
            <ItemDetailInfo title={'UPC'} value={lineItem.universalProductCode} position={'left'} />
            <ItemDetailInfo title={'UOM'} value={lineItem.unitOfMeasure} position={'left'} />
            <div className={'lineitem-card-action-button'}>
                <ActionButton
                    icon={faThumbsUp}
                    iconSize={'1x'}
                    buttonText={'Select'}
                    buttonColor={'#82BC24'}
                    onClick={() => onClickButton(lineItem)}
                />
            </div>
        </div>
    )
}

